export enum UsuarioSistemaPerfilEnum {
    AdministradorDoSistema = 1,
    Diretor = 2,
    Consultor = 3,
    Gerente = 4,
    Vendedor = 5,
    Parceiro = 6,
    Industria = 7,
    Comprador = 8,
    SuporteTecnico = 9,
    AdministradorDeCampanha = 10,
    GerenteGeral = 11,
    GestorDeCompras = 12,
    AdministradorDeCarteira = 18,
    GestorDeSincronizacao = 19
}
